import Swiper from "swiper";
import {Autoplay, FreeMode} from "swiper/modules";


document.addEventListener('DOMContentLoaded', () => {

    const logoSwiper = new Swiper('.swiper-logo', {
        breakpoints: {
            // when window width is >= 320px
            600: {
                slidesPerView: 2.5,
                spaceBetween: 10
            },
            760: {
                slidesPerView: 3.8,
                spaceBetween: 10
            },
            // when window width is >= 480px
            960: {
                slidesPerView: 4.2,
                spaceBetween: 10
            },
            // when window width is >= 640px 
            1280: {
                slidesPerView: 4.8, 
                spaceBetween: 20
            },
            1360: {
                slidesPerView: 5.5,
                spaceBetween: 20
            }
        },
        autoplay: {
            delay:1
        },
        slidesPerView: 2,
        speed:6500,
        loop: true,
        centeredSlides: false,
        spaceBetween: 15,
        on: {
            reachEnd: function () {
                this.slideTo(0, 0);
            }
        },
        freeMode:true,
        modules: [Autoplay, FreeMode],
    });
});
